import ButtonArrow from '@img/icons/icon-button-arrow.svg';
import ButtonDownloadIcon from '@img/icons/icon-download.svg';
import Location from '@img/icons/location.svg';
import OneKey from '@img/logos/brand/OneKey.svg';
import React, { FunctionComponent, ReactNode } from 'react';
import { IconVisibilityT } from './Button';
import { ButtonIcon, ButtonStyles } from './Button.styles';

export type LinkIcon = 'none' | 'arrow' | 'download' | 'location' | 'onekey';

export type LinkTheme =
  | 'red'
  | 'red-white'
  | 'white'
  | 'black'
  | 'black-grey'
  | 'transparent'
  | 'green'
  | 'white-red'
  | 'white-outline';

export interface LinkProps {
  text?: string;
  theme?: LinkTheme | string;
  size?: 'small' | 'normal';
  icon?: LinkIcon;
  iconPlacement?: 'before' | 'after';
  iconVisibility?: IconVisibilityT;
  textTheme?: 'black';
  underline?: boolean;
  href?: string;
  target?: '_blank' | '_self' | string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const Link: FunctionComponent<LinkProps> = ({
  text,
  href,
  textTheme,
  theme = 'red',
  size = 'normal',
  underline = false,
  target = '_self',
  icon = 'none',
  iconPlacement = 'after',
  iconVisibility,
  disabled = false,
  onClick,
  ...rest
}) => {
  function shouldRenderIcon(): IconVisibilityT {
    if (iconVisibility) {
      return iconVisibility;
    }

    if (icon === null || icon === undefined || icon === 'none') {
      return 'never';
    }
    if (icon === 'download') {
      return 'always';
    }

    return 'onHover';
  }

  const _iconVisibility: IconVisibilityT = shouldRenderIcon();

  return (
    <ButtonStyles.LinkElement
      {...rest}
      theme={theme}
      textTheme={textTheme}
      size={size}
      underline={underline}
      href={href}
      target={target}
      data-icon={icon}
      data-icon-visibility={_iconVisibility}
      data-icon-placement={iconPlacement}
      disabled={disabled}
      iconPadding={!icon || icon !== 'none'}
      onClick={onClick}
      data-track={true}
      data-text={text}
    >
      {iconPlacement === 'before' && renderIcon(icon)}
      {icon !== 'onekey' && text}
      {iconPlacement === 'after' && renderIcon(icon)}
    </ButtonStyles.LinkElement>
  );
};

function renderIcon(icon: LinkIcon): ReactNode {
  switch (icon) {
    case 'none': {
      return null;
    }

    case 'onekey': {
      return (
        <ButtonIcon>
          <OneKey />
        </ButtonIcon>
      );
    }

    case 'download': {
      return (
        <ButtonIcon>
          <ButtonDownloadIcon />
        </ButtonIcon>
      );
    }

    case 'location': {
      return (
        <ButtonIcon>
          <Location />
        </ButtonIcon>
      );
    }

    default:
    case 'arrow': {
      return (
        <ButtonIcon>
          <ButtonArrow />
        </ButtonIcon>
      );
    }
  }
}

export default Link;
